import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import { colors, mixins, H3, breakpoints } from "../css-variables"
import GravityForm from '../atoms/GravityForm'

const SidebarForm = () => {
  const { allWpGfForm } = useStaticQuery(
    graphql`
    query {
      allWpGfForm(filter: {databaseId: {eq: 8}}) {
        edges {
          node {
            databaseId
            description
            descriptionPlacement
            title
            formFields {
              nodes {
                type
                ... on WpEmailField {
                  
                  label
                  isRequired
                  inputs {
                    id
                    label
                    
                    
                  }
                  placeholder
                  visibility
                  cssClass
                  description
                  descriptionPlacement
                  conditionalLogic {
                    actionType
                    logicType
                    rules {
                      fieldId
                      operator
                      value
                    }
                  }
                  errorMessage
                }
                ... on WpTextField {
                  
                  label
                  isRequired
                  placeholder
                  value
                  visibility
                  inputName
                  maxLength
                  errorMessage
                  description
                  descriptionPlacement
                  defaultValue
                  cssClass
                  conditionalLogic {
                    actionType
                    logicType
                    rules {
                      fieldId
                      operator
                      value
                    }
                  }
                }                    
                ... on WpSectionField {
                  
                  conditionalLogic {
                    actionType
                    logicType
                    rules {
                      fieldId
                      operator
                      value
                    }
                  }
                  cssClass
                  description
                  displayOnly
                  label
                  visibility
                }
                ... on WpHtmlField {
                  
                  conditionalLogic {
                    actionType
                    logicType
                    rules {
                      fieldId
                      operator
                      value
                    }
                  }
                  content
                  cssClass
                  label
                  type
                  visibility
                }
              }
            }
           
            confirmations {
              message
            }
          }
        }
      }
}
    `
  )
  return allWpGfForm
}

const Form = ({ className, id=8, homepage }) => {
  const gfData = SidebarForm()
  //console.log(gfData)
  const homepageWrapClass = homepage ? 'homepage' : 'nomargin'
  return (
    <div className={`${className} ${homepageWrapClass}`}>
      <div>
        {!homepage && <H3>Want to Stay in the Know?</H3>}
        {homepage && <h2>Want to Stay in the Know?</h2>}
        <hr/>
        <GravityForm
          id={8}
          formData={gfData}
        />
      </div>
    </div>
  )
}

const StyledSidebarForm = styled(Form)`
${mixins.formStyles}
${mixins.fixed_width_element}
&.homepage{
  ${mixins.fixed_width_content_pad}
  ${mixins.fixed_width_element}
  @media screen and ${breakpoints.laptopS} {
    max-width: 712px !important;
  }
}
> div {
  ${mixins.fixed_width_content_pad}
}
h3{
  color: ${colors.textGrey}
}
p{
  margin-bottom: 24px;
}
hr{
  background-color: ${colors.rulesGrey};
  width: 48px;
  height: 4px;
  margin: 24px 0;
}
`
export default StyledSidebarForm